export const gridSettings = {
  pageable: {
    alwaysVisible: true,
    pageSizes: [5,10,25,50,'all'],
    buttonCount: 20
  },
  filterable: {
    operators: {
      string: {
        contains: 'Contains',
        startswith: 'Starts with'
      },
      number: {
        gte: 'Greater than or equal to',
        lte: 'Less than or equal to',
        lt: 'Less than',
        gt: 'Greater than',
        eq: 'Equal to'
      },
      date: {
        lt: 'Before',
        gt: 'After',
        eq: 'On',
        lte: 'Before or On',
        gte: 'After or On'
      }
    }
  }
};